import store from "../../globals";
import { axiosInstance } from "./axiosInstance";

const RESOURCE_URL_V2 = process.env.REACT_APP_API_URL_V2 + "/admin/campus/";

export class DashboardService {
    sessionToken = store.getState().sessionToken.value
    campusId     = store.getState().currentUserCampusId.value
    constructor()
    {
        store.subscribe
        (
            ()=>
            {
                this.sessionToken = store.getState().sessionToken.value
                this.campusId     = store.getState().currentUserCampusId.value
            }
        )
    }
    
    getData = async ( params?: Record<string, any>) => {
        let uri = RESOURCE_URL_V2 + this.campusId + "/dashboard/students";

        let response = await axiosInstance.get(uri, { params });
        return response;
    }

}
export default DashboardService;